import { MDBContainer } from "mdb-react-ui-kit";
import { Avatar } from "antd";

import "react-datepicker/dist/react-datepicker.css";

import "../PassportDetails.css";

import BottomNavigationBar from "../BottomNavigation";

import AllowHotelMadinaGridFilter from "./AllowHotelMadinaGridFilter";

const AllowHotelMadina = () => {
  return (
    <>
      <div className="background-image-hotel">
        <MDBContainer breakpoint=" p-4">
          <div className="main-wrapper">
            <div>
              <div
                className="navebar"
                style={{ background: "", width: "100%", marginBottom: "20px" }}
              >
                <img className="logo" src={window.logo} alt="logo" />
                <Avatar
                  className="profile"
                  alt="Remy Sharp"
                  src={window.profile}
                />
              </div>

              <AllowHotelMadinaGridFilter />
            </div>
          </div>
        </MDBContainer>
        <div>
          <BottomNavigationBar />
        </div>
      </div>
    </>
  );
};

export default AllowHotelMadina;
